import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

import translateEN from "./locales/en/translation.json";
import commonEN from "./locales/en/common.json";
import errorEN from "./locales/en/error.json";
import translateCH from "./locales/ch/translation.json";
import commonCH from "./locales/ch/common.json";
import errorCH from "./locales/ch/error.json";

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    // 监听语言更改事件并设置 HTML lang 属性
    .on('languageChanged', (lng) => {
        document.documentElement.lang = lng;
    })
    .init({
        ns: ['translation', 'common', 'error'],
        defaultNS: 'common',
        supportedLngs: ['ch', 'en'],
        fallbackLng: 'ch',
        // debug: true,
        resources: {
            en: {
                translation: translateEN,
                common: commonEN,
                error: errorEN,
            },
            ch: {
                translation: translateCH,
                common: commonCH,
                error: errorCH,
            }
        },
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['path'],
            lookupFromPathIndex: 1,
            caches: '',
        }
    });

export default i18n;